// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__XXoy4","tab-item":"tab_tab-item__0lQdU","tab-list":"tab_tab-list__x1H++","tab-list__indicator":"tab_tab-list__indicator__N26tW"};